import { combineReducers } from 'redux';
import * as actions from '../actions';
import * as orderActions from '../../orders/actions';
import { Reducer } from '../../../types';

type State = {
  needClose: boolean;
};


type Actions = ReturnType<ValueOf<typeof actions>>;
type OrderActions = ReturnType<ValueOf<typeof orderActions>>;
type ReducerOf<T extends keyof State> = Reducer<State, Actions | OrderActions, T>;

const needClose: ReducerOf<'needClose'> = (state = false, action) => {
  switch (action.type) {
    case actions.setNeedCloseModal.type:
      return action.payload;

    case orderActions.cancelOrderSuccess.type:
      return true;
    default:
      return state;
  }
};

export default combineReducers<State>({
  needClose,
});
